module.exports = __webpack_public_path__ + "1b85a7c9640327fbc883a581fe0fbb40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Splash/images/slides/slide2.jpg
// module id = ./src/views/Splash/images/slides/slide2.jpg
// module chunks = 0